import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/svgs/icon_change.svg';
const _hoisted_1 = {
  class: "area-info"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "area-info-divider"
}, null, -1);

const _hoisted_3 = {
  class: "area-info-text"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "area-info-action-icon",
  src: _imports_0
}, null, -1);

const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "area-info-action-text"
}, " 切换 ", -1);

const _hoisted_6 = [_hoisted_4, _hoisted_5];

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "area-info-divider"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_picker = _resolveComponent("van-picker");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.areaName), 1), _createElementVNode("div", {
    class: "area-info-action",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.showAreaChangePicker = true)
  }, _hoisted_6), _hoisted_7, _createVNode(_component_van_popup, {
    show: _ctx.showAreaChangePicker,
    position: "bottom",
    round: "",
    "safe-area-inset-bottom": true,
    teleport: "body"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      title: "请选择小区",
      columns: _ctx.areaNames,
      onConfirm: _ctx.onConfirm,
      onCancel: _cache[1] || (_cache[1] = $event => _ctx.showAreaChangePicker = false)
    }, null, 8, ["columns", "onConfirm"])]),
    _: 1
  }, 8, ["show"])]);
}